<template>
  <div class="ui container">
    <div class="right floated">
      <button @click="refresh()" class="ui small icon button"><i class="sync icon"></i></button>
    </div>
    <vuetable ref="vuetable"
              api-url="/mm/apply"
              :sort-order="sortOrder"
              :fields="fields"
              @vuetable:pagination-data="onPaginationData">
      <template slot="actions" scope="props">
        <button class="ui button" :class="{disabled: props.rowData.accept}" @click="accept(props.rowData.id)">批准</button>
        <button class="ui button" :class="{disabled: props.rowData.accept!=null}" @click="reject(props.rowData.id)">拒绝</button>
      </template>
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
  </div>
</template>

<script>
import axios from 'axios'
import Vuetable from '@/table/Vuetable'
import VuetablePagination from '@/table/VuetablePagination'

export default {
  name: 'ApplyList',
  components: {
    Vuetable,
    VuetablePagination,
  },
  data () {
    return {
      sortOrder: [
        {
          field: 'id',
          direction: 'desc'
        }
      ],
      fields: [
        { name: 'id', title: 'ID' },
        { name: 'user.id', title: '用户ID' },
        { name: 'user.username', title: '用户名' },
        { name: 'cat.name', title: '喵喵用户', callback: 'link' },
        { name: 'cat.avatar', title: '头像', callback: 'avatar' },
        { name: 'cat.starid', title: '明星ID', callback: 'star' },
        { name: 'comment', title: 'comment' },
        { name: 'time', title: '申请时间', callback: 'date' },
        { name: 'accept', title: '已批准' },
        { name: '__slot:actions', title: '操作' },
      ],
    }
  },
  methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    refresh () {
      this.$refs.vuetable.reload()
    },
    avatar (val, item) {
      return '<a href="/#/mm/users/' + item.cat.id + '"><img class="ui tiny image" src="' + val + '"></a>'
    },
    link (val, item) {
      return '<a href="/#/mm/users/' + item.cat.id + '">' + val + '</a>'
    },
    star (val) {
      return '<a href="/#/mm/stars/' + val + '">' + val + '</a>'
    },
    date: function (value) {
      return value ? new Date(value).toLocaleString() : ''
    },
    accept(id) {
      axios.post('/admin/mm/apply/' + id).then(() => {
        this.refresh()
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
    reject(id) {
      axios.delete('/admin/mm/apply/' + id).then(() => {
        this.refresh()
      }, (err) => {
        this.$toasted.error(err.message)
      })
    },
  }
}
</script>

<style scoped>
.right.floated {
  float: right;
  margin-top: -50px;
}
</style>
